export default __webpack_public_path__ + "static/media/icon-show.3528778f.svg";